import { ContentRelayDto } from '@diritto/common/relay/dtos/content-relay.dtos';
import { ProfileLiteRelayDto } from '@diritto/common/relay/dtos/profile-lite-relay.dtos';
import { TrackerExtraInfoProps } from '@diritto/common/tracker/tracking-event.constant';
import { SectionRelayDto } from '@diritto/common/relay/dtos/section-relay.dtos';
import { SectionContentLites } from 'app-components/home/sections/SectionContentLites';
import { isSectionContentDto } from 'utils/sectionContentUtils';

type SectionProps = {
  section: SectionRelayDto;
  contents: Record<number, ContentRelayDto>;
  profileLites: Record<number, ProfileLiteRelayDto>;
};

export const SectionRankLites = (props: SectionProps & TrackerExtraInfoProps) => {
  if (!isSectionContentDto(props.section)) {
    return null;
  }

  return <SectionContentLites {...props} section={props.section} />;
};
export default SectionRankLites;
